import styled from 'styled-components';

const HeaderIcon = styled.a`
`;

export default HeaderIcon;
